import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-00b841fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "expertise",
  class: "section responsibility"
}
const _hoisted_2 = { class: "responsibility__list" }

import SectionHeading from "@/components/SectionHeading.vue";
import { expertisePillars } from "@/data/profile";

export default /*#__PURE__*/_defineComponent({
  __name: 'ResponsibilityAreas',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(SectionHeading, {
      eyebrow: "Expertise",
      title: "Die Expertise hinter der Verantwortung.",
      description: "Meine Arbeit verbindet Firmenaufbau, Anforderungsanalyse, Softwarearchitektur, KI/RAG und technische Führung. Entscheidend ist nicht die einzelne Fähigkeit, sondern das Zusammenspiel."
    }),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(expertisePillars), (area) => {
        return (_openBlock(), _createElementBlock("article", {
          key: area.title,
          class: "responsibility__item"
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("h3", null, _toDisplayString(area.title), 1),
            _createElementVNode("p", null, _toDisplayString(area.summary), 1)
          ]),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(area.points, (point) => {
              return (_openBlock(), _createElementBlock("li", { key: point }, _toDisplayString(point), 1))
            }), 128))
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})